import Vue from "vue";

export default {
  data() {
    return {
    };
  },
  methods: {

    trackEvent(event) {  
      let eventStr = "Page Event: Application and access dashboard"
      let addtlParams = {}
      addtlParams.subEvent = event
      
      this.$hhMixpanel.trackEvent(eventStr, addtlParams)    
    }
  }
}
